import React from "react";
import {Button} from "react-bootstrap";
import MySelect from "../../components/form/mySelect";
import FormGroup from "../../components/formGroup";
import {isObject} from "lodash";
import MyCard from "../../components/myCard";

function InterventionConseilSocial(props) {
    const commande = isObject(props.selected)
        ? props.selected
        : props.commandes.find(f => f.value === props.selected);

    return (
        <section>
            <MyCard header={"Remboursement syllabi à destination des étudiants boursiers"}
                    body={
                        <>
                            <p>Le service social de l'ICHEC intervient dans l'achat <b>des syllabi</b> (pas des livres)
                                lorsqu'un
                                étudiant est déclaré comme ayant une bourse acceptée pour l'année académique concernée
                                par
                                la commande SIC.</p>
                            <p>La demande de cette intervention peut être soumise via cet encadré, il est également
                                possible
                                de consulter l'état d'avancement de la demande.</p>
                            <div>
                                <FormGroup label={"Commande concernée"}
                                           name={"Commande"}
                                           type={MySelect}
                                           value={commande}
                                           options={props.commandes}
                                           onChange={props.onChange.bind(this)}
                                           required={false}/>
                            </div>
                            <hr/>
                            <div className={"text-center mb-2"}>
                                {commande && commande.EstBoursier && commande.Message === null && commande.CommandeMontantSyllabus > 0 &&
                                    <>
                                        <Button size="lg" variant="success" onClick={props.onCreate.bind(this)}>
                                            Créer une intervention
                                        </Button>
                                    </>}
                                <p className={commande && commande.Message?.includes("correctement") ? "text-success" : (commande && commande.Message?.includes("traitée") ? "text-purple" : "text-danger")}>
                                    {commande && commande.Message || ''}
                                </p>
                            </div>
                        </>
                    }/>
        </section>
    );
}

export default InterventionConseilSocial;